import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Label from 'components/v2/forms/Label';
import { ArrowLeftIcon, ArrowRightIcon, ChevronDoubleLeftIcon, ChevronDoubleRightIcon, } from '@heroicons/react/20/solid';
import CircleButton from 'components/v2/buttons/CircleButton';
export default function MultiSelectTable({ selectedColumnName, availableColumnName, columnNamesClassName, selectedItems, allItemsList, onSelect, }) {
    const [required, setRequired] = useState(selectedItems);
    const [available, setAvailable] = useState([]);
    const [selectRequired, setSelectRequired] = useState([]);
    const [selectAvailable, setSelectAvailable] = useState([]);
    const findAvailable = (required) => {
        const req = new Set(required.map((req) => req.value));
        const availableDocs = allItemsList.filter((doc) => !req.has(doc.value));
        setAvailable(availableDocs);
    };
    useEffect(() => {
        findAvailable(required);
    }, [required]);
    useEffect(() => {
        setRequired(selectedItems);
        findAvailable(selectedItems);
    }, [selectedItems]);
    const addToRequired = (value) => {
        const newRequired = required.concat(value);
        setRequired(newRequired);
        onSelect(newRequired);
    };
    const removeFromRequired = () => {
        const remove = new Set(selectRequired.map((req) => req.value));
        const newRequired = required.filter((doc) => !remove.has(doc.value));
        setRequired(newRequired);
        onSelect(newRequired);
    };
    const handleEmptyingRequired = () => {
        setRequired([]);
        onSelect([]);
    };
    const handleSelectedRequired = (e) => {
        var _a;
        const newRequired = Array.from((_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.selectedOptions, (option) => {
            var _a;
            const found = allItemsList.find((item) => item.value === option.value);
            return found
                ? {
                    name: found.name,
                    value: found.value,
                }
                : {
                    name: (_a = option.value) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
                    value: option.value,
                };
        });
        setSelectRequired(newRequired);
    };
    const handleSelectedAvailable = (e) => {
        const newAvailable = Array.from(e.target.selectedOptions, (option) => {
            var _a;
            const found = allItemsList.find((item) => item.value === option.value);
            return found
                ? {
                    name: found.name,
                    value: found.value,
                }
                : {
                    name: (_a = option.value) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
                    value: option.value,
                };
        });
        setSelectAvailable(newAvailable);
    };
    return (React.createElement("div", { className: "flex -mx-4 justify-between items-center overflow-x-auto" },
        React.createElement("div", { className: "px-4" },
            React.createElement(Label, { labelClassName: classnames(columnNamesClassName) }, selectedColumnName),
            React.createElement("div", { className: "py-2" },
                React.createElement("select", { className: "border-gray-100 shadow text-sm h-80 w-auto sm:w-52 rounded-md overflow-auto", multiple: true, onChange: handleSelectedRequired }, required.map((doc) => (React.createElement("option", { className: "py-1 text-sm text-gray-700", key: doc.value, value: doc.value }, doc.name)))))),
        React.createElement("div", { className: "px-4 space-y-2" },
            React.createElement(CircleButton, { onClick: () => {
                    addToRequired(available);
                }, size: "small", className: "mt-2" },
                React.createElement(ChevronDoubleLeftIcon, { className: "w-4 h-4" })),
            React.createElement(CircleButton, { onClick: () => {
                    addToRequired(selectAvailable);
                }, size: "small", className: "mt-2", color: "brand" },
                React.createElement(ArrowLeftIcon, { className: "w-4 h-4" })),
            React.createElement(CircleButton, { onClick: removeFromRequired, size: "small" },
                React.createElement(ArrowRightIcon, { className: "w-4 h-4" })),
            React.createElement(CircleButton, { onClick: handleEmptyingRequired, size: "small", className: "mt-2" },
                React.createElement(ChevronDoubleRightIcon, { className: "w-4 h-4" }))),
        React.createElement("div", { className: "px-4" },
            React.createElement(Label, { labelClassName: classnames(columnNamesClassName) }, availableColumnName),
            React.createElement("div", { className: "py-2" },
                React.createElement("select", { className: "border-gray-100 shadow text-sm h-80 w-auto sm:w-52 rounded-md overflow-auto", multiple: true, onChange: handleSelectedAvailable }, available.map((doc) => (React.createElement("option", { className: "py-1 text-sm text-gray-700", key: doc.value, value: doc.value }, doc.name))))))));
}
MultiSelectTable.propTypes = {
    selectedColumnName: PropTypes.string.isRequired,
    availableColumnName: PropTypes.string.isRequired,
    columnNamesClassName: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
    selectedItems: PropTypes.arrayOf(PropTypes.object),
    allItemsList: PropTypes.arrayOf(PropTypes.object),
    onSelect: PropTypes.func.isRequired,
};
MultiSelectTable.defaultProps = {
    selectedItems: [],
    allItemsList: [],
};
